import React from 'react';
import Hero from './components/IQAC/contact/Hero';
import Main from './components/IQAC/contact/Main';

const IqacContact = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacContact;